import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  font-size: 12px;
`;

const ErrorImageContainer = styled.div`
  max-width: 300px;
  margin: 0 auto;
`;

const ErrorImage = styled.img`
  max-width: 100%;
  width: auto;
  height: auto;

  &:hover {
    animation: shake 0.5s;
    animation-iteration-count: infinite;
  }
  @keyframes shake {
    0% {
      transform: translate(1px, 1px) rotate(0deg);
    }
    10% {
      transform: translate(-1px, -2px) rotate(-1deg);
    }
    20% {
      transform: translate(-3px, 0px) rotate(1deg);
    }
    30% {
      transform: translate(3px, 2px) rotate(0deg);
    }
    40% {
      transform: translate(1px, -1px) rotate(1deg);
    }
    50% {
      transform: translate(-1px, 2px) rotate(-1deg);
    }
    60% {
      transform: translate(-3px, 1px) rotate(0deg);
    }
    70% {
      transform: translate(3px, 1px) rotate(-1deg);
    }
    80% {
      transform: translate(-1px, -1px) rotate(1deg);
    }
    90% {
      transform: translate(1px, 2px) rotate(0deg);
    }
    100% {
      transform: translate(1px, -2px) rotate(-1deg);
    }
  }
`;

const ErrorMessageContainer = styled.div`
  max-width: 50%;
  margin: 0 auto;
`;

const Description = styled.p`
  margin: 10px;
`;

export const GeneralError = () => (
  <ErrorContainer data-testid='general-error'>
    <ErrorImageContainer>
      <ErrorImage src='/images/icons/r2o_illustration_faces_07_1000x.png' alt='Unexpected error' title='r2o_error_logo' />
    </ErrorImageContainer>
    <ErrorMessageContainer>
      <h2>Something went wrong!</h2>
      <h2>Etwas ist schief gelaufen!</h2>
      <Description>
        Please try again later or contact us{' '}
        <a href='https://support.ready2order.com/l/de' title='An unexpected error occured, please try again later or contact us here.'>
          here
        </a>
      </Description>
      <Description>
        Bitte versuchen Sie es später noch einmal oder kontaktieren Sie uns{' '}
        <a
          href='https://support.ready2order.com/l/de'
          title='Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal oder kontaktieren Sie uns hier.'
        >
          hier
        </a>
      </Description>
    </ErrorMessageContainer>
  </ErrorContainer>
);
